export enum NotificationTypes {
    task = 1,
    email = 2,
    project = 3,
    missing_info = 4,
    appointment = 5,
    client = 6,
    company = 7,
    step = 8,
    files = 9,
    todo = 10,
}